{
  "post-office.jsm-phantom.issue-view.playbook.spotlight-close-button": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-first-line": [
    {
      "type": 0,
      "value": "Use playbooks to follow step‑by‑step guidance and run automated actions to resolve work faster."
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-heading": [
    {
      "type": 0,
      "value": "Resolve work items faster with playbooks"
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more about playbooks"
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight-second-line": [
    {
      "type": 0,
      "value": "If no playbook exists for this work item, share your team’s runbooks or how‑tos with your project admin so they can turn them into actionable playbooks for your team."
    }
  ],
  "post-office.jsm-phantom.issue-view.playbook.spotlight.create-playbook": [
    {
      "type": 0,
      "value": "View playbooks"
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-close-button": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-first-line": [
    {
      "type": 0,
      "value": "Create playbooks to give your team clear step‑by‑step guidance and automated actions, so they resolve work items faster and more consistently."
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-heading": [
    {
      "type": 0,
      "value": "Turn your team’s knowledge and processes into actionable playbooks"
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more about playbooks"
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight-second-line": [
    {
      "type": 0,
      "value": "Ask your teams to share their runbooks, SOPs, and how‑tos, and turn them into reusable playbooks available in context on every work item."
    }
  ],
  "post-office.jsm-phantom.space-settings.playbook-nav.spotlight.create-playbook": [
    {
      "type": 0,
      "value": "Create a playbook"
    }
  ]
}